import { useBuildVars } from '../config';
import { useApiQuery } from '../api';
import { Option } from '@im/ui-lib/SelectOption';

export interface DealSearchRequest {
  businessType: string | null;
  countryCode: string;
  dealNameToSearch: string;
}

export interface ProgramSearchRequest {
  businessType: string | null;
  programName: string;
  vendorIDToSearch: number;
}

export interface DealSearchResponse {
  deal_name: string;
  importreferenceid: number;
}

export interface VendorSearchResponse {
  importreferenceid: number;
  vendor_name: string;
}

export interface ProgramSearchResponse {
  importreferenceid: number;
  program_name: string;
}

export function useSimpleSearchLookUp(params: DealSearchRequest) {
  const buildVars = useBuildVars();
  return useApiQuery<DealSearchResponse[]>(
    '/system.webapi.gds/api/v1/GdsCoreApiDeals/searchByName',
    params,
    { enabled: params.dealNameToSearch.length > 1 },
    undefined,
    {
      host: buildVars.VP_API_BASE,
    }
  );
}
export function useSimpleSearchBusinessTypesLookUp(params: DealSearchRequest) {
  const buildVars = useBuildVars();
  return useApiQuery<DealSearchResponse[]>(
    '/system.webapi.gds/api/v1/GdsCoreApiDeals/SearchByNameAcrossBusinessTypes',
    params,
    { enabled: params.dealNameToSearch.length > 1 },
    undefined,
    {
      host: buildVars.VP_API_BASE,
    }
  );
}

export function useSimpleSearchProgramLookUp(params: ProgramSearchRequest) {
  const buildVars = useBuildVars();
  return useApiQuery<Option[]>(
    '/system.webapi.gds/api/v1/gdsCoreApiVendor/subscriptionvendorProgram',
    params,
    { enabled: params.programName.length > 1 },
    undefined,
    {
      host: buildVars.VP_API_BASE,
    }
  );
}
